import styled from 'styled-components';

// Material-UI
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// *************************************
// STYLED COMPONENTS
// *************************************

// Switch Label
export const StyledSwitchLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    margin-left: -10px;
  }

  .MuiTypography-root {
    /* font-family: 'Bryant Pro Regular'; */
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;

// Switch
export const StyledSwitch = styled(Switch)`
  .MuiCheckbox-root {
    color: ${(props) => props.theme.colors.greyDark};
    padding: 8px;
  }

  .MuiSwitch-switchBase.Mui-checked {
    color: ${(props) => props.theme.colors.blueMedium};
  }

  .MuiSwitch-colorSecondary.Mui-checked:hover {
    background-color: ${(props) => props.theme.colors.blueMediumAlpha};
  }

  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    background-color: ${(props) => props.theme.colors.blueMedium};
  }
`;
